import { TableComment } from "../../../../general/src/TableComment";
import { Button, DataHeader, DataSource, HorizontalSpacer, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelIndex extends Layout {
    buttonAddColumn: Button;
    dataheaderCustomFuelIndex: DataHeader;
    horizontalspacerSpacer: HorizontalSpacer;
    layoutTableComment: TableComment;
    panelHeaderFields: Panel;
    panelPrices: Panel;
    panelRegions: Panel;
    panelTableHeader: Panel;
    sourceComments: DataSource;
    sourceCustomFscIndex: DataSource;
    sourceCustomFscPrice: DataSource;
    tabComments: Tab;
    tabPrices: Tab;
    tabRegionConfig: Tab;
    tableCustomFscPrice: Table;
    tabsetCustomFuelIndex: Tabset;
    textboxDescr: Textbox;
    textboxIndexId: Textbox;
    textboxRegion10: Textbox;
    textboxRegion11: Textbox;
    textboxRegion12: Textbox;
    textboxRegion13: Textbox;
    textboxRegion14: Textbox;
    textboxRegion15: Textbox;
    textboxRegion16: Textbox;
    textboxRegion1: Textbox;
    textboxRegion2: Textbox;
    textboxRegion3: Textbox;
    textboxRegion4: Textbox;
    textboxRegion5: Textbox;
    textboxRegion6: Textbox;
    textboxRegion7: Textbox;
    textboxRegion8: Textbox;
    textboxRegion9: Textbox;
}
